import { action, orchestrator } from 'satcheljs';
import showFullOptions from './showFullOptions';
import confirmDirtyOptionsAndPerformAction from './confirmDirtyOptionsAndPerformAction';

const navigateToSearchSuggestion = action(
    'navigateToSearchSuggestion',
    (category: string, subcategory: string, option: string) => ({ category, subcategory, option })
);

export default navigateToSearchSuggestion;

orchestrator(navigateToSearchSuggestion, actionMessage => {
    const continueAfterConfirmCallback = () => {
        showFullOptions(actionMessage.category, actionMessage.subcategory, actionMessage.option);
    };

    confirmDirtyOptionsAndPerformAction(continueAfterConfirmCallback);
});
